import AbroadModal from './AbroadModal';
export default AbroadModal;
